import type { HTTPResponseError } from "./http";

export enum HTTPMethod {
	GET = "GET",
	POST = "POST",
	PATCH = "PATCH",
	PUT = "PUT",
	DELETE = "DELETE",
	HEAD = "HEAD",
}

export type HTTPHeader = Record<string, string>;
export type HTTPParams = Record<string, any>;
export type HTTPRequestConfig = {
	ignoreError?: boolean;
	timeout?: number;

	method: HTTPMethod;
	headers: HTTPHeader;
	params?: HTTPParams;
	body?: any | null;
	version?: number;
};

export type ProxyResult<T> =
	| {
			status: "SUCCESS";
			data: T;
	  }
	| {
			status: "FAILED";
			data?: unknown;
	  };

export type HTTPErrorCallback = (error: HTTPResponseError) => void;

/**
 * Callback function to modify the config
 */
export type HTTPRequestHook = (
	endpoint: string,
	config: HTTPRequestConfig
) => Promise<HTTPRequestConfig> | HTTPRequestConfig;
